import { useEffect } from 'react';
import { useSession } from '../identity/session';
import { useTasks } from '../tasks/api';

type BadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

/** Number of due and overdue tasks on the app icon (Badging API, where supported). */
export function useAppBadge(): void {
  const { can } = useSession();
  const tasks = useTasks({ view: 'today' }, can('tasks.read'));
  const count = tasks.data?.length;
  useEffect(() => {
    const nav = navigator as BadgeNavigator;
    if (count === undefined || !nav.setAppBadge) return;
    const apply = count > 0 ? nav.setAppBadge(count) : nav.clearAppBadge?.();
    apply?.catch(() => undefined);
  }, [count]);
}
